import React from 'react';

/**
 * BlurredLine component renders a horizontal line with a blurred shadow effect.
 * @returns {JSX.Element} - JSX element representing the BlurredLine component
 */
const BlurredLine = () => {
    return (
        <hr style={{ boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.8)' }} />
    )
};

export default BlurredLine;
